import { render, staticRenderFns } from "./CardTour.vue?vue&type=template&id=5ec44695&scoped=true"
import script from "./CardTour.vue?vue&type=script&lang=js"
export * from "./CardTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec44695",
  null
  
)

export default component.exports